import React from 'react';
import logo from '../../../../../images/c3Link-Horizontal-white.png';
import './LeftDrawerHeader.css';
import { injectIntl } from 'react-intl';
import { getRegionalColors } from '../../../../../utils/regional-colors';

const LeftDrawerHeader = (props) => (
  <div>
    <h1
      className="logo"
      style={{
        backgroundColor: getRegionalColors().backgroundColor
      }}
    >
      <img src={logo} alt="C3 Link" />
    </h1>
    <div className="avatar"
         style={{
           backgroundColor: getRegionalColors().backgroundColor
         }}
    >
      {`${props.intl.formatMessage({ id: 'drawer.welcome' })}, ${
        props.user.commonName
      }`}
    </div>
  </div>
);

export default injectIntl(LeftDrawerHeader);
